
import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment'
import router from './router'
import VuexPersistence from 'vuex-persist'
Vue.use(Vuex)

export default new Vuex.Store({
  strict: false, // 🔥 disable strict (huge perf gain)

  state: {
    barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
    drawer: true,
    notification: {
      available: false,
      msgtype: 'success',
      message: ''
    },
    session: {lastactivity: '',
      token: '',
      refresh: '',
      expiry: '',
      user: '', 
      username: '',
      userid: '', 
      passwordchanged: true,
      loggedin: true, 
      account: [],
      objects: [] // grouped structure
    },
    server_time: '',
    assets_version: 0,
    activeClass: '',
    playNotifications: true,
    isMobileMode: '',
    isSubMenuVisible: true,
    isFirstClick: false,
    hideSubMenu: false,
    objects_loaded: false,
    selected_object: [],
    selected_group: "",
    object_center: '',
    last_sync_id: '',
    events: { 
      last_event_id: '',
      unread_events: []
    } 
  },
   getters: {
    isLoggedIn: state => {  
      if (!state.session.loggedin || !moment(state.session.expiry).isValid() ||
          (moment().isAfter(moment(state.session.expiry)) && 
          moment().diff(moment(state.session.expiry), 'minutes') > 5)) {
        return true
      } else 
        return true
    },

    isTimeCorrect: state => {
      return state.server_time === null ? true : !moment().isBefore(moment(state.server_time))
    },

    mylastactivity: state => {
      return state.session.lastactivity === null ? null : state.session.lastactivity
    }
  },

  mutations: { 
    SET_MODE(state,payload) {
      state.isMobileMode = payload
    },
    SET_LAST_SYNC(state,payload) {
      state.last_sync_id = payload
    },
    BUMP_ASSETS_VERSION(state) {
      state.assets_version = (state.assets_version || 0) + 1
    },
    SET_PLAY_MODE(state,payload) {
      state.playNotifications = payload
    },
    SET_DRAWER(state, payload) {
      state.drawer = payload
    },
    SET_SUB_DRAWER(state, payload) {
      state.hideSubMenu = payload
    },
    SET_ACTIVE_GROUP(state, payload) {
      state.selected_group = payload
    },
     SET_MAIN_MENUCLICK(state,payload){
      state.isFirstClick = payload
    },
    SET_ACTIVE_CLASS(state, payload) {
      state.activeClass = payload
    },
    SET_DRAWER (state, payload) {
      state.drawer = payload
    },
    UPDATE_LAST_ACTIVITY: (state) => {
      state.session.lastactivity =  moment()
    },
    UPDATE_PASSWORD_CHANGED: (state,payload) => {
      state.session.passwordchanged =  payload
    },
    RESET_NOTIFICATION: (state) => {
      state.notification.available = false
      state.notification.msgtype = ''
      state.notification.message = ''
    },
    SET_NOTIFICATION: (state, obj) => {
      state.notification.available = true
      state.notification.msgtype = obj.type
      state.notification.message = obj.msg
    },
    SET_ACTIVE_OBJECT: (state, obj) => { 
      state.selected_object = obj
    },
    ReSET_ACTIVE_OBJECT: (state) => { 
      state.selected_object = []
    },
    AUTHENTICATE: (state, jwt) => {
      state.session.lastactivity = moment()
      state.session.token = jwt.token
      state.session.account = jwt.account
      state.session.refresh = jwt.refresh 
      state.session.expiry = jwt.expiration 
      state.session.loggedin = true 
      state.events.last_event_id = '';
      state.events.last_event_date = moment();
      state.events.unread_events = null;
      state.selected_object = '' 
    },
    UPDATE_EVENT: (state,events)=> {
      state.events.last_event_id = events[0].event_id; 

      let original = state.events.unread_events || [];
      original.push(...events); 
      if (original.length > 20) {
          original = original.slice(-20);
      } 
      state.events.unread_events = original;
    },

    READ_EVENT: (state,eventID)=> {  
      state.events.unread_events = state.events.unread_events.filter(e => e.event_id !== eventID);
    },

    RESET_EVENTS: (state)=> {
      state.events.last_event_id = ''; 
      state.events.unread_events = [];
    },
    LOG_OUT: (state) => {
      state.session.lastactivity = moment()
      state.session.token = ''
      state.session.expiry = ''
      state.session.user = ''
      state.session.username = ''
      state.session.userid = '' 
      state.server_time = ''
      state.session.passwordchanged = false
      state.session.loggedin = false 
      state.session.account = []
      state.session.objects = []
      state.selected_object = ''
      state.notification.available = false;
      state.objects_loaded = false;
      state.notification.message = '';
      state.events.last_event_id = ''; 
      state.events.unread_events = []
      state.selected_object = ''  
      localStorage.clear()
      router.push("/");
    },
    // 🚀 INITIAL LOAD (NO REACTIVITY EXPLOSION)
    SET_OBJECTS_INITIAL(state, payload) {
      state.session.objects = payload.objects; // keep mutable (needed for updates)
      state.object_center = payload.center;
    },

    // 🚀 FAST UPDATE (O(n))
    UPDATE_OBJECTS(state, updates) { 
      // build index once
      const index = {};

      state.session.objects.forEach(group => {
        (group.children || []).forEach(child => {
          index[child.imei] = child;
        });
      });

      // apply updates
      updates.forEach(item => {
        const existing = index[item.imei];
        if (!existing) return;

        existing.lat = item.lat;
        existing.lng = item.lng;
        existing.speed = item.speed;
        existing.angle = item.angle;
        existing.current_loc = item.current_loc;
        existing.loc_valid = item.loc_valid;
        existing.engineon = item.engineon;
        existing.last_update = item.last_update;
        // When this asset was last merged from the server. The client ages the
        // "last seen" label from here (the server's relative string is frozen).
        existing.last_update_at = Date.now();
      });
    },

    SET_OBJECTS_LOADED(state, payload) {
      state.objects_loaded = payload;
    },

    SET_ACTIVE_OBJECT(state, imei) {
      state.selected_object = imei;
    }
  },

  actions: { 
    // 🚀 INITIAL LOAD
    initObjects({ commit }, payload) {
      commit('SET_OBJECTS_INITIAL', payload);
      commit('SET_OBJECTS_LOADED', true);
    },

    // 🚀 WORKER-BASED UPDATE
    updateObjects({ commit }, updates) {
      commit('UPDATE_OBJECTS', updates);
    },

    set_last_sync_date({ commit }, dt) {
      commit('SET_LAST_SYNC', dt);
    },

    // Central poller (Platform) calls this after every successful /objects sync
    // so live views (the map) can re-read the IndexedDB cache.
    notify_assets_updated({ commit }) {
      commit('BUMP_ASSETS_VERSION');
    },

    select_object({ commit }, imei) {
      commit('SET_ACTIVE_OBJECT', imei);
    },

     LOG_IN (context, jwt) {
      context.commit('AUTHENTICATE', jwt)
    },

    logout (context) {
      context.commit('LOG_OUT')
    },

    register_vehicles (context,vehicles) { 
      context.commit('SET_OBJECTS',vehicles)
    },

    update_device_loaded(context,data){
      context.commit('SET_OBJECTS_LOADED',data);
    },

    select_active_group(context,group){
      context.commit('SET_ACTIVE_GROUP',group);
    },

    select_object(context,imeino){
      context.commit('SET_ACTIVE_OBJECT',imeino)
    },

    reset_selected_object(context){
      context.commit('ReSET_ACTIVE_OBJECT')
    },

    set_map_center(context,center){
      context.commit('SET_MAP_CENTER',center)
    },
    
    mark_event_read(context,eventID){
      context.commit('READ_EVENT',eventID)
    },

    set_last_event(context,events){
      context.commit('UPDATE_EVENT',events)
    },

    reset_last_event(context){
      context.commit('RESET_EVENTS')
    }  
  },
  plugins: [new VuexPersistence().plugin]
});